import { gql } from '@apollo/client';
import { CORE_TOOL_CATEGORY_FIELDS } from './tool-category';
import { CORE_TOOL_TYPE_FIELDS } from './tool-type';

export const CORE_TOOL_CATALOG_FIELDS = gql`
  fragment CoreToolCatalogFields on ToolCatalog {
    id
    bscnPartNumber
    name
    inventoryType
    toolCategoryId
    uomId
    isFavorite
    isLocked
    limitCount
    toolCatalogImageUrl
    uom {
      id
      abbreviation
    }
    projectToolCatalog {
      id
      isLocked
      limitCount
    }
  }
`;

export const SEARCH_TOOL_CATALOGS = gql`
  ${CORE_TOOL_CATALOG_FIELDS}
  ${CORE_TOOL_TYPE_FIELDS}
  ${CORE_TOOL_CATEGORY_FIELDS}
  query SearchToolCatalogs($searchInput: SearchInput) {
    searchToolCatalogs(searchInput: $searchInput) {
      items {
        ...CoreToolCatalogFields
        toolCategory {
          ...CoreToolCategoryFields
          toolType {
            ...CoreToolTypeFields
          }
        }
      }
    }
  }
`;

export const GET_TOOL_CATALOG_COUNT = gql`
  query GetToolCatalogCount($searchInput: SearchInput) {
    toolCatalogsCountForSearch(searchInput: $searchInput)
  }
`;
